import KmAllButton from '../km-select/select-all-button'
KmAllButton.install = function (vue) {
  vue.component(KmAllButton.name, KmAllButton)
}
export default KmAllButton



// WEBPACK FOOTER //
// ./src/ui/components/km-select-all/index.js